<template>
        <div class="col-lg-9">


            <div class="d-flex align-items-center mb-4 justify-content-between">
                <h3 class="text-7 mb-0">
                    {{wallet.content.type}} {{ wallet.content.currency}} Wallet
                </h3>
                <router-link
                    v-if="wallet.content.type === 'Biller' && hasPermission(permissions, 'request-payout')"
                    :to="`/business/wallets/payout/${$route.params.id}/request`"
                    class="btn btn-success btn-sm px-3 shadow-none"
                >
                    <i class="fas fa-university"></i> Request Payout
                </router-link>
                <router-link
                    v-if="wallet.content.type === 'Corporate' && hasPermission(permissions, 'input-transactions')"
                    :to="`/business/wallets/deposit`"
                    class="btn btn-success btn-sm px-3 shadow-none"
                >
                    <i class="fas fa-arrow-down"></i> Fund Wallet
                </router-link>
            </div>

            <div class="row gy-4 profile-completeness" v-if="wallet.content.type ==='Biller'">
                <div class="col-12 col-sm-12 col-lg-3 mb-2">
                    <div class="shadow-sm rounded text-center bg-white px-3 py-4 position-relative">
                        <small class="service-text-small">Statement Balance</small>
                        <i class="fas fa-info-circle info-icon" data-toggle="tooltip" data-placement="top" title="The total balance in your wallet, reflecting all your transactions."></i>
                        <hr>
                        <p class="mb-0 text-3 service-text"><b>{{ wallet.content.currency}} {{ money(wallet.content.balance)}}</b></p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-lg-3 mb-2">
                    <div class="shadow-sm rounded text-center bg-white px-3 py-4 position-relative">
                        <small class="service-text-small">Pending Clearance</small>
                        <i class="fas fa-info-circle info-icon" data-toggle="tooltip" title="Funds in the holding period that will become available after clearance."></i>
                        <hr>
                        <p class="mb-0 text-3 service-text"><b>{{ wallet.content.currency}} {{ money(wallet.content.holding_funds)}}</b></p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-lg-3 mb-2">
                    <div class="shadow-sm rounded text-center bg-white px-3 py-4 position-relative">
                        <small class="service-text-small">Available Balance</small>
                        <i class="fas fa-info-circle info-icon" data-toggle="tooltip" title="The amount you can request to withdraw immediately, excluding pending clearance."></i>
                        <hr>
                        <p class="mb-0 text-3 service-text"><b>{{ wallet.content.currency}} {{ money(wallet.content.available_balance)}}</b></p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-lg-3 mb-2">
                    <div class="shadow-sm rounded text-center bg-white px-3 py-4 position-relative">
                        <small class="service-text-small">Net Payout Value</small>
                        <i class="fas fa-info-circle info-icon" data-toggle="tooltip"
                           :title="`The final amount you will receive after deducting payout fees of ${wallet.content.payout_fee} ${wallet.content.currency}.`">
                        </i>

                        <hr>
                        <p class="mb-0 text-3 service-text"><b>{{ wallet.content.currency}} {{ money(wallet.content.net_payout)}}</b></p>
                    </div>
                </div>

            </div>

            <div class="custom-nav-container my-3">
                <ul class="custom-nav-tabs">
                    <li class="custom-nav-item">
                        <router-link class="custom-nav-link"
                                     :class="{ active: $route.path.includes('/view') }"
                                     :to="`/business/wallet/${$route.params.id || ''}/view`">
                            Statement
                        </router-link>
                    </li>
                    <li class="custom-nav-item"  v-if="wallet.content.type === 'Biller'">
                        <router-link class="custom-nav-link"
                                     :class="{ active: $route.path.includes('/payouts') }"
                                     :to="`/business/wallet/${$route.params.id || ''}/payouts`">
                           Payouts
                        </router-link>
                    </li>
                </ul>

                <div class="custom-nav-underline">
                    <div class="custom-nav-active-underline"
                         :style="{ left: activeTabPosition, width: activeTabWidth }">
                    </div>
                </div>
            </div>

            <keep-alive>
                <transition name="slide-in-left">
                    <router-view :data="data" :wallet="wallet"></router-view>
                </transition>
            </keep-alive>

        </div>
</template>


<script>
import Data from "../../../core/data/Data";
import Form from "../../../core/forms/form";
import Statement from "../../wallets/statement.vue";
import {money} from "../../../core/forms/money";
import {datesMixin} from "../../../core/data/global";
import FormattedDate from "../../core/FormattedDate.vue";

export default {
    name: "Index",
    components: {FormattedDate, Statement},
    props: ['permissions'],
    mixins: [money, datesMixin],
    data(){
        return {
            data :  new Data({
                url : `/business/wallets/${this.$route.params.id}/view/api`,
                prefix : "list"
            }),
            wallet :  new Data({
                url : `/business/wallets/${this.$route.params.id}/view/api`,
                prefix : "wallet"
            }),
            message:'',
            tempStartDate: '',
            tempEndDate: '',
            form: new Form({
                startDate: '',
                endDate: ''
            }),
            activeTabPosition: "0px",
            activeTabWidth: "0px",
        };
    },
    methods : {
        updateActiveTabPosition() {
            this.$nextTick(() => {
                const activeTab = document.querySelector(".custom-nav-tabs .custom-nav-link.active");
                if (activeTab) {
                    this.activeTabPosition = `${activeTab.offsetLeft}px`;
                    this.activeTabWidth = `${activeTab.offsetWidth}px`;
                }
            });
        },
        initializeTooltips() {
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },
    },
    mounted() {
        this.data.fetch().then(() => {
            this.updateActiveTabPosition();
        });
        this.wallet.fetch().then(() => {
            this.updateActiveTabPosition();
        });

        this.initializeTooltips();
    },
    updated() {
        this.initializeTooltips();
    },
    watch: {
        "$route.path": function () {
            this.$nextTick(() => {
                this.updateActiveTabPosition();
            });
        }
    }
}
</script>

<style scoped>

.info-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 14px;
    color: #6c757d;
    cursor: pointer;
}

.info-icon:hover {
    color: #007bff;
}

</style>
